import { Serializable } from "../../../tendercuts/models/base";

export class WeightValidationResponse implements Serializable<WeightValidationResponse> {

   public status: boolean;
   public message: string;
   public weight: number;

  deserialize(input) {
    if(!input) {
       return;
    }
    
    this.status = input.status;
    this.message = input.message;
    this.weight = input.weight;

    return this;
  }
}
